import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { APIsEndPoints } from '../utilities/apis.endpoints';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {
  private selectedCrewRating: any;
  private selectedSafetyRating: any;
  isChartView = true;
  constructor(private http: HttpClient) { }

  getAllRatings(period?: string) {
    return this.http.get(`${APIsEndPoints.GET_ALL_RATINGS}/${period}`);
  }

  getAllRatingsData(period,firm,outlier) {
    return this.http.get(`${APIsEndPoints.GET_RATINGS_FIRM}?period=${period}&firm=${firm}&outlier=${outlier}`);
  }

  listCrewRatings(crewId: string, rank: string = 'current',outlier) {
    return this.http.get(`${APIsEndPoints.LIST_CREW_RATINGS}?crewId=${crewId}&rank=${rank}&outlier=${outlier}`);
  }

  getCrewRatings(crewId: string, rank: string = 'current',outlier) {
    return this.http.get(`${APIsEndPoints.GET_CREW_RATINGS}?crewId=${crewId}&rank=${rank}&outlier=${outlier}`);
  }

  getCrewRanks(crewId: string) {
    return this.http.get(`${APIsEndPoints.GET_ALL_RANKS}/${crewId}`);
  }

  getCrewListByCrewName(crewName: string) {
    return this.http.get(`${APIsEndPoints.GET_LIST_ALL_SUGGESTION}/${crewName}`);
    // return this.http.get(`${APIsEndPoints.BASE_URL}/ratings/listCrewRatingsByName/${crewName}`);
  }

  getRatingDetails(ratingId: string) {
    return this.http.get(`${APIsEndPoints.GET_RATING_DETAILS}/${ratingId}`);
  }

  setSelectedRating(crewRating: any) {
    this.selectedCrewRating = crewRating;
  }

  getSelectedRating() {
    return this.selectedCrewRating;
  }

  setSelectedSafetyRating(safetyRating: any) {
    this.selectedSafetyRating = safetyRating;
  }

  getSelectedSafetyRating() {
    return this.selectedSafetyRating;
  }

  getAllRatingsByFirm(period,firm){
    return this.http.get(`${APIsEndPoints.GET_RATINGS_FIRM}?period=${period}&firm=${firm}&outlier=true`);
  }

  getRatingsByFilter(body: any){
    return this.http.post(`${APIsEndPoints.GET_RATING_BY_FILTERS}`, body);
  }

  getQuestionAvgRating(body: any){
    return this.http.post(`${APIsEndPoints.GET_QUESTIONS_AVG_RATING}`, body);
  }
}

